import { TextInput, Button, Group, Stack } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useForm } from '@mantine/form';
import type { Owner } from '@/types/company';

interface OwnerFormProps {
  initial: Owner | null;
  onSave: (data: Omit<Owner, 'id' | 'companyId'>) => void;
  onCancel: () => void;
  loading: boolean;
}

export function OwnerForm({ initial, onSave, onCancel, loading }: OwnerFormProps) {
  const form = useForm({
    initialValues: {
      firstName: initial?.firstName ?? '',
      lastName: initial?.lastName ?? '',
      dateOfBirth: initial?.dateOfBirth ? new Date(initial.dateOfBirth) : null as Date | null,
    },
    validate: {
      firstName: (v) => (v.trim() ? null : 'Vorname ist erforderlich'),
      lastName: (v) => (v.trim() ? null : 'Nachname ist erforderlich'),
      dateOfBirth: (v) => (v ? null : 'Geburtsdatum ist erforderlich'),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    onSave({
      firstName: values.firstName,
      lastName: values.lastName,
      dateOfBirth: values.dateOfBirth!.toISOString().split('T')[0]!,
    });
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="sm">
        <TextInput label="Vorname" required {...form.getInputProps('firstName')} />
        <TextInput label="Nachname" required {...form.getInputProps('lastName')} />
        <DateInput
          label="Geburtsdatum"
          required
          valueFormat="DD.MM.YYYY"
          maxDate={new Date()}
          {...form.getInputProps('dateOfBirth')}
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>Abbrechen</Button>
          <Button type="submit" loading={loading}>Speichern</Button>
        </Group>
      </Stack>
    </form>
  );
}
